export const SET_HEADER_SEARCH = 'SET_HEADER_SEARCH'
export const CLEAR_HEADER_SEARCH = 'CLEAR_HEADER_SEARCH'
export const CREDIT_MODAL = 'CREDIT_MODAL'
export const AUTH_MODAL = 'AUTH_MODAL'
